import React from "react";

export const close = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57 10.7139L49.2852 3L30 22.2861L10.7139 3L3 10.7139L22.2852 30L3 49.2861L10.7139 57L30 37.7139L49.2852 57L57 49.2861L37.713 30L57 10.7139Z"
        fill="currentColor"
      />
    </svg>
  );
};
